import React, {FC} from 'react'
import {BadgeStatus} from '@mdsol/onex-design'

import {CellPropsType} from './cellPropsType'

const JobTypeCell: FC<CellPropsType> = ({cell}) => {
  const jobType = cell.getValue() ?? ''
  const label = jobType.replaceAll('_', ' ')

  return <BadgeStatus dataTestId='job-type-badge-status' type='neutral'>{label}</BadgeStatus>
}

export default JobTypeCell
